import { GroupByPipe } from './../common/pipes/group-by.pipe';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { JsonSchemaFormModule } from 'angular4-json-schema-form-updated';
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import { NgSelectizeModule } from 'ng-selectize';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxBarcodeModule } from 'ngx-barcode';
import { AccordionModule, BsDatepickerModule, BsDropdownModule, PopoverModule, TabsModule, TooltipModule } from 'ngx-bootstrap';
import { TagInputModule } from 'ngx-chips';
import { DropdownModule } from 'ngx-dropdown';
import { MaskPipe, NgxMaskModule } from 'ngx-mask';
import { ModalModule } from 'ngx-modal';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppCommonModule } from '../common/app-common.module';
import { CCPipe } from '../common/pipes/cc-value-format.pipe';
import { CurrencyTransformPipe } from '../common/pipes/currency-format.pipe';
import { TitleCasePipe } from '../common/pipes/title-case.pipe';
import { TranslateKey } from '../common/pipes/translate-key.pipe';
import { EnrollmentCommonService } from '../shared/services/enrollment-common.service';
import { EnrollmentMessageService } from './services/enrollment-message.service';
import { PersonalMessageService } from './services/personal-schema-form.service';
import { CustomerServiceRoutingModule } from './customer-service-routing.module';
import { CustomerServiceConstants } from './customer-service.constants';
import { DuplicateIdentificationTypeDirective } from './directive/duplicate-identification-type.directive';
import { AchService } from './services/ach.service';
import { AddressService } from './services/address.service';
import { AppConfigService } from './services/app-config.service';
import { BatchProcessingService } from './services/batch-processing.service';
import { CreditCardTypeService } from './services/card-type.service';
import { CheckoutConfigService } from './services/checkout-config.service';
import { ConfigurationService } from './services/configuration.service';
import { CustomerService } from './services/customer.service';
import { DepartmentService } from './services/department.service';
import { DocumentService } from './services/document.service';
import { EcheckService } from './services/echeck.service';
import { EmailLogService } from './services/email-log.service';
import { EnrollService } from './services/enrollment.service';
import { NIService } from './services/networkinternational.service';
import { OrderConfigService } from './services/order-config.service';
import { OrderMapperService } from './services/order-mapper.service';
import { OrderService } from './services/order.service';
import { PayvisionService } from './services/payvision.service';
import { PersonalInfoTitleConfigService } from './services/persoanl-info-title-config.service';
import { PersonalInfoConfigService } from './services/personal-info-config.service';
import { ShippingAddressInfoConfigService } from './services/shipping-config.service';
import { SpinnerService } from './services/spinner.service';
import { SponsorConfigService } from './services/sponsor-config.service';
import { SponsorService } from './services/sponsor.service';
import { WorldpayXMLService } from './services/worldpay-xml.service';
import { CustomDatePickerComponent } from './widgets/custom-datepicker.widget';
import { CustomMaskTextboxComponent } from './widgets/custom-mask-textbox.widget';
import { CustomSelectWidgetComponent } from './widgets/custom-select.widget';
import { CustomInputComponent } from './widgets/custom-textbox.widget';
import { ReportService } from './services/report.service';
import { CopyToClipboardDirective} from './directive/copy-to-clipboard.directive';
import { NexioService } from './services/nexio.service';
import { RetailSubscriptionService } from './services/retail-subscription.service';
import { GroupByLevelModule } from './models/group-by-level/group-by-level.module';
import { DecimalDirective } from './directive/decimal.directive';
import { AnonymousRetailOrderService } from './services/anonymous-retail-order.service';
import { OutsideClickDirective } from './directive/outside-click.directive';
import { AdyenPaymentService } from './services/adyen-payment.service';
import { IbanFormat } from '../common/pipes/iban-format.pipe';


export const MY_MOMENT_FORMATS = {
  parseInput: 'MMM YYYY',
  fullPickerInput: 'l LT',
  datePickerInput: 'DD-MMM-YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@NgModule({
  imports: [
    AppCommonModule,
    NgSelectizeModule,
    NgSelectModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxPaginationModule,
    CustomerServiceRoutingModule,
    TabsModule.forRoot(),
    AccordionModule.forRoot(),
    OwlDateTimeModule, OwlMomentDateTimeModule,
    FileUploadModule,
    ModalModule,
    PopoverModule.forRoot(),
    NguiAutoCompleteModule,
    CreditCardDirectivesModule,
    NgxMaskModule.forRoot(),
    TooltipModule.forRoot(),
    HttpClientModule,
    HttpClientJsonpModule,
    JsonSchemaFormModule,
    DropdownModule,
    CKEditorModule,
    TagInputModule,
    NgxBarcodeModule,
    CommonModule,
    GroupByLevelModule
  ],
  declarations: [CustomerServiceConstants.MODULE_COMPONENTS,DuplicateIdentificationTypeDirective,CopyToClipboardDirective,DecimalDirective, OutsideClickDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [CustomerService, DatePipe, CurrencyTransformPipe, CCPipe, MaskPipe, IbanFormat,
    DepartmentService, OrderService, CreditCardTypeService, AddressService,
    PayvisionService, EcheckService, WorldpayXMLService,AdyenPaymentService,NIService,NexioService, OrderMapperService,AchService,
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'en' },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
    EmailLogService, TranslateKey, EnrollService, EnrollmentMessageService, SponsorService,
    EmailLogService, DocumentService, TranslateKey,
    TranslateKey, EnrollService, EnrollmentMessageService, SpinnerService,AppConfigService, ShippingAddressInfoConfigService,
    CheckoutConfigService, SponsorConfigService, TitleCasePipe, PersonalMessageService, PersonalInfoConfigService, ConfigurationService,PersonalInfoTitleConfigService,
    EnrollmentCommonService, OrderConfigService, BatchProcessingService, ReportService, RetailSubscriptionService, AnonymousRetailOrderService
  ],
  exports: [CustomerServiceConstants.MODULE_COMPONENTS, CustomSelectWidgetComponent, CustomMaskTextboxComponent, HttpClientModule,
    HttpClientJsonpModule, JsonSchemaFormModule],
  entryComponents: [CustomSelectWidgetComponent, CustomMaskTextboxComponent, CustomInputComponent,
    CustomDatePickerComponent]
})
export class CustomerServiceModule {

}



// WEBPACK FOOTER //
// ./src/app/customerservice/customer-service-module.ts